import React from "react";
import "./CenterIllustration.css";

import CenterArt from "../Assets/cow-farming-center.png"; 
// Replace with your actual file

const CenterIllustration = () => {
  return (
    <section className="centerIllustrationSection anim anim-top">
      <div className="centerIllustrationWrapper">
        <img
          src={CenterArt}
          alt="Cow and Farmer Illustration"
          className="centerIllustrationImg"
        />
      </div>
    </section>
  );
};

export default CenterIllustration;
